module.exports = __webpack_public_path__ + "img/check-circle.ec1dbeb4.svg";